import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiGatewayService, RequestParams } from '~app/shared/api-gateway.service';

@Injectable()
export class InfluxService extends ApiGatewayService {
  constructor(protected http: HttpClient) {
    super(http, 'influx');
  }

  public getMeasurements(
    bucket: string,
    filters: RequestParams = {},
  ): Promise<{ [key: string]: string }[]> {
    return this.get(['buckets', bucket, 'measurements'], filters);
  }

  public getFields(
    bucket: string,
    measurement: string,
    filters: RequestParams = {},
  ): Promise<{ [key: string]: string }[]> {
    return this.get(['buckets', bucket, 'measurements', measurement, 'fields'], filters);
  }

  public async getFieldValues(
    bucket: string,
    measurement: string,
    field: string,
    filters: RequestParams = {},
  ): Promise<[string, number | string | boolean][]> {
    return this.get(['buckets', bucket, 'measurements', measurement, 'fields', field], filters);
  }
}
